export default __webpack_public_path__ + "locales/zh-CN/SmartBanner.json?hash=c13195a14ba16b7e928a4fb96c8346ce";